"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
exports.default = (0, react_1.createContext)({
    locale: undefined,
    imageStaticSourcesByFileName: {},
    dimentions: {
        window: { height: 0, width: 0 },
        screen: { height: 0, width: 0 },
        statusBarHeight: 0,
    },
    Animated: {},
    Render: {
        MapView: () => null,
        BannerAd: () => null,
        Calendar: () => null,
        Camera: () => null,
        CheckBox: () => null,
        DatePicker: () => null,
        FlatList: () => null,
        GooglePlacesAutocomplete: () => null,
        Graphic: () => null,
        Image: () => null,
        ImageBackground: () => null,
        KeyboardAvoidingView: () => null,
        Lottie: () => null,
        MapCircle: () => null,
        MapMarker: () => null,
        MapPolyLine: () => null,
        MapPolygon: () => null,
        Modal: () => null,
        PickerView: () => null,
        RotationLock: () => null,
        SafeAreaView: () => null,
        ScrollView: () => null,
        SectionList: () => null,
        SkeletonContent: () => null,
        Slider: () => null,
        StatusBar: () => null,
        SvgIcon: () => null,
        SvgImage: () => null,
        Switch: () => null,
        Text: () => null,
        TextInput: () => null,
        TextInputMask: () => null,
        TouchableOpacity: () => null,
        Video: () => null,
        VideoView: () => null,
        View: () => null,
        AnimatedImage: () => null,
        AnimatedView: () => null,
        AnimatedFlatList: () => null,
        CameraView: () => null,
        WebView: () => null,
        JitsiMeet: () => null,
        ImageViewer: () => null,
        InterstitialAd: () => null,
    },
    functions: {
        listenerBackHandler: undefined,
        processor: {},
        generateControlEvents: undefined,
    },
    wrappers: {
        renderChildrenWrapper: undefined,
        renderControlWrapper: undefined,
    },
});
